import React from 'react';
import {ChartComponentProps} from '@/views/storyboard/charts/ChartContainer';
import {getChartDataTotal} from '@/views/storyboard/utils/calculations/chartTotal';
import {AggregationsChartData} from 'entities/chartData';
import SunburstChart from './SunburstChart';
import {
    aggregationsToSunburstTree,
    filterAggregationsChartRows,
    getMultiTermsKeyPartCount,
    getSunburstLevelCount,
    isHierarchicalAggregationOutput,
} from '../utils/aggregationsToSunburstTree';
import {DataLabelPosition} from 'entities/chart';
import ChartIndicators from '@/views/storyboard/charts/utils/ChartIndicators';

export type SunburstChartData = AggregationsChartData;

const SunburstChartWrapper = React.memo<ChartComponentProps>(({
    dataLooselyTyped,
    width,
    height,
    title,
    queryDuration = '0',
    chartSettingsView,
    chartQuery,
    dataLabelPosition = DataLabelPosition.Off,
    description = '',
    datePeriod = '',
    onPreviewFooterChange,
}) => {
    const data = filterAggregationsChartRows(dataLooselyTyped);
    const isHierarchical = isHierarchicalAggregationOutput(chartQuery.output);

    const filtered = data.filter((row) => row.docCount !== 0 && row.key !== 'Other');
    const treeData = aggregationsToSunburstTree(filtered, isHierarchical);
    const keyPartCount = isHierarchical ? getMultiTermsKeyPartCount(filtered) : 0;
    const levelCount = getSunburstLevelCount(treeData, keyPartCount);
    const total = getChartDataTotal(filtered, ['docCount']);

    return (
        <>
            <SunburstChart
                data={treeData}
                levelCount={levelCount}
                height={height}
                width={width}
                chartSettingsView={chartSettingsView}
                title={title}
                dataLabelPosition={dataLabelPosition}
                description={description}
                datePeriod={datePeriod}
            />
            <ChartIndicators
                total={total}
                totalComparable={0}
                trendValue="0"
                queryDuration={queryDuration}
                chartQueryOutput={undefined}
                chartSettingsView={chartSettingsView}
                onPreviewFooterChange={onPreviewFooterChange}
            />
        </>
    );
});

export default SunburstChartWrapper;
